/**
 * Single source of truth for provenance and attribution.
 *
 * Who operates this service is available on every public page. That is provenance,
 * the same discipline applied to any cited source. It is not a disclaimer and
 * it is not written in a legal register.
 *
 * The test suite asserts these render on every public page, so attribution
 * cannot be dropped quietly.
 */

export const PRODUCT_NAME = 'MUSTER'
export const PRODUCT_TAGLINE = 'Manpower Utilization, Scheduling, Tracking, and Enterprise Readiness'

/** Who operates the service. */
export const OPERATOR = {
  name: 'MetaPhase',
  url: 'https://metaphase.tech',
} as const

/** How the system was delivered. */
export const DELIVERY =
  'Mission Protoware, built by MPworks and delivered with ChallengeAI.'

/**
 * ChallengeAI is how this was built, never a feature of what was built. Copy
 * that describes a capability as powered by ChallengeAI is wrong.
 */
export const ACCELERATOR =
  'ChallengeAI is the accelerator applied during engineering.'

/** Byline naming the operator. Rendered in the footer of the public pages. */
export const ATTRIBUTION = `${PRODUCT_NAME} is built and operated by ${OPERATOR.name}.`

export const BUILT_BY = `Built by ${OPERATOR.name}`

export const COPYRIGHT_YEAR = 2026
